import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation,useNavigate } from 'react-router-dom';
import { getLucideIcon } from '@utils/getLucideIcon';
import { fetchJson } from '@utils/fetchJson';
import clsx from 'clsx';
import { API_BASE_URL } from '../config';
import { Menu } from 'lucide-react';

const SidebarWithSubmenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const submenuRef = useRef(null);
  const [menuList, setMenuList] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
const isFirstLoadRef = useRef(true);
const userPermission = localStorage.getItem('userPermission');
//console.log(userPermission);
useEffect(() => {
  if (!isFirstLoadRef.current) return; // skip if not first load

  const matchingParent = menuList.find(menu =>
    menu.subMenu?.some(sub => location.pathname.includes(sub.menuLink))
  );

  if (matchingParent) {
    setOpenMenu(matchingParent.menuID);
  }

  isFirstLoadRef.current = false; // disable future runs
}, [location.pathname, menuList]);


useEffect(() => {
  const loadMenus = () => {
    const localData = localStorage.getItem('appMenu');
    const userPermission = localStorage.getItem('userPermission');
    let permissions = {};
    if (userPermission) {
      permissions = JSON.parse(userPermission);
    }
    // function filterMenus(menus) {
    //   return (menus || []).filter(menu => {
    //     const key = menu.menuLink;
    //     if (permissions[key]?.module_access !== 'yes' || permissions[key]?.view !== 'yes') return false;

    //     if (menu.subMenu && Array.isArray(menu.subMenu)) {
    //       menu.subMenu = menu.subMenu.filter(sub => {
    //         const subKey = sub.menuLink;
    //         return permissions[subKey]?.module_access === 'yes';
    //       });
    //     }
    //     return true;
    //   });
    // }
    
    function filterMenusByPermission(menus, permissions) {
      return (menus || []).reduce((acc, menu) => {
        const key = menu.menuLink;
        const menuPerm = permissions[key] || {};

        // Recursively check submenus first
        const filteredSubMenus = menu.subMenu ? filterMenusByPermission(menu.subMenu, permissions) : [];

        // Show this menu if:
        // - It has view permission OR
        // - Any of its child menus are visible
        const canView = menuPerm.module_access === "yes" && menuPerm.view === "yes";
        if (canView || filteredSubMenus.length > 0) {
          acc.push({ ...menu, subMenu: filteredSubMenus });
        }
        return acc;
      }, []);
    }


    if (localData) {
      let data = JSON.parse(localData);
      //let filteredMenus = filterMenus(data?.data);
      let filteredMenus = filterMenusByPermission(data?.data, permissions);
      setMenuList(filteredMenus.sort((a, b) => a.menuIndex - b.menuIndex));
    }
  };

  loadMenus();

  window.addEventListener('refreshSidebarMenu', loadMenus);
  return () => window.removeEventListener('refreshSidebarMenu', loadMenus);
}, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (submenuRef.current && !submenuRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

//  const handleClick = (menu) => {
//   if (!menu.subMenu || menu.subMenu.length === 0) {
//     // Navigate directly if no submenu
//     if (menu.menuLink) {
//       navigate(`/${menu.menuLink}`);
//       setOpenMenu(null);
//     }
//     setShowMobileMenu(false);
//   } else {
//     // Toggle submenu
//     setOpenMenu(menu.menuID);
//     setShowMobileMenu(false);
//   }
// };
const handleClick = (e, menu) => {
  if (e.ctrlKey || e.metaKey || e.button === 1) {
    // ✅ Open in new tab (Ctrl+Click or Middle Click)
    const url = `/${menu.menuLink}`;
    window.open(url, "_blank", "noopener,noreferrer");
    e.preventDefault();
    return;
  }

  if (!menu.subMenu || menu.subMenu.length === 0) {
    // Normal click → navigate
    if (menu.menuLink) {
      navigate(`/${menu.menuLink}`);
      setOpenMenu(null);
    }
    setShowMobileMenu(false);
  } else {
    // Toggle submenu
    setOpenMenu(menu.menuID);
    setShowMobileMenu(false);
  }
};


  const isActive = (menuLink) => location.pathname.includes(menuLink);
  
  const activeMenu = menuList.find((m) => m.menuID === openMenu);

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
  className="
    lg:hidden fixed top-2 left-1 z-50
    p-1
    text-gray-700
    rounded-full
    transition
    hover:bg-gray-200 active:bg-gray-300
    hover:scale-110 active:scale-95
    duration-150
    focus:outline-none
  "
  onClick={() => setShowMobileMenu(!showMobileMenu)}
>
  <Menu size={24}/>
</button>
      {/* Left Sidebar  #6466e3,#353766 #f7f7f7,#d9dbdf #1a1c1e,#001d21rgb(3, 0, 33) */}
      <aside
        className={clsx(
          'w-20 bg-[linear-gradient(#2d385b,#1a1c1e)] h-[calc(100vh-40px)] fixed top-[40px] flex flex-col items-center py-4 space-y-3 shadow z-40 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 transition-transform duration-300',
          'lg:left-0',
          showMobileMenu ? 'left-0' : 'left-[-100%] lg:left-0'
        )}
      >
        {menuList.map((menu) => {
  const Icon = getLucideIcon(menu.iconName);
  const hasSubMenu = menu.subMenu && menu.subMenu.length > 0;
  const isActiveMenu =
    openMenu === menu.menuID ||
    location.pathname.includes(menu.menuLink) ||
    menu.subMenu?.some(sub => location.pathname.includes(sub.menuLink));

  return (
    <a
      key={menu.menuID}
      href={`/${menu.menuLink || "#"}`}
      target="_self"
      rel="noopener noreferrer"
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) return;
        e.preventDefault();
        handleClick(e, menu);
      }}
      className={clsx(
        "relative w-full flex flex-col items-center justify-center py-2 transition-all duration-200 group",
        "hover:bg-white/10 hover:backdrop-blur-md hover:ring-1 hover:ring-white/10 hover:shadow-inner",
        isActiveMenu &&
          "bg-white/10 backdrop-blur-md ring-1 ring-white/10 shadow-inner"
      )}
    >
      <Icon
        size={20}
        className={clsx(
          "transition-colors duration-200",
          isActiveMenu
            ? "text-amber-400"
            : "text-gray-400 group-hover:text-amber-400"
        )}
      />
      <span
        className={clsx(
          "text-[11px] mt-1 transition-opacity duration-300 text-center",
          isActiveMenu
            ? "text-amber-400 font-medium"
            : "text-white group-hover:text-amber-400 opacity-80"
        )}
      >
        {menu.menuName}
      </span>

      {/* 🔹 Small glassy triangle indicator for submenu */}
      {hasSubMenu && (
   <span
    className={clsx(
      "absolute bottom-[4px] right-[5px] w-0 h-0",
      // ⬇️ Make triangle bigger — 7px instead of 5px
      "border-l-[7px] border-l-transparent border-b-[7px] border-b-white/30",
      "group-hover:border-b-amber-400/70 transition-all duration-300",
      isActiveMenu && "border-b-amber-400/80"
    )}
  />
)}
    </a>
  );
})}
      </aside>

      {/* Submenu */}
      {activeMenu?.subMenu?.length > 0 && (
        <div
          ref={submenuRef}
          className="ml-20 w-64 h-[calc(100vh-48px)] bg-white shadow-lg fixed top-[48px] z-30 p-4 overflow-y-auto animate-slide-in"
        >
          {activeMenu.subMenu
            .sort((a, b) => a.menuIndex - b.menuIndex)
            .map((sub) => {
              const SubIcon = getLucideIcon(sub.iconName);
              return (
                // <NavLink
                //   to={`/${sub.menuLink}`}
                //   key={sub.menuID}
                //   onClick={() => setOpenMenu(null)}  // <-- hide submenu on click
                //   className={({ isActive }) =>
                //     clsx(
                //       'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium mb-2 transition-all duration-200',
                //       isActive ? 'bg-primary-50 text-orange-300' : 'hover:bg-gray-100'
                //     )
                //   }
                // ><SubIcon size={16} className="inline mr-2 text-gray-500" />
                //   {sub.menuName}
                // </NavLink>
                <a
  href={`/${sub.menuLink}`}
  key={sub.menuID}
  target="_self"
  rel="noopener noreferrer"
  onClick={(e) => {
    // Support middle/ctrl-click to open in new tab
    if (e.ctrlKey || e.metaKey || e.button === 1) return; 
    e.preventDefault();
    navigate(`/${sub.menuLink}`);
    setOpenMenu(null);
  }}
  className={clsx(
    'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium mb-2 transition-all duration-200',
    location.pathname.includes(sub.menuLink)
      ? 'bg-primary-50 text-orange-300'
      : 'hover:bg-gray-100'
  )}
>
  <SubIcon size={16} className="inline mr-2 text-gray-500" />
  {sub.menuName}
</a>

              );
            })}
        </div>
      )}
    </>
  );
};
export default SidebarWithSubmenu;